import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPageSeo } from '../utils/seo';

/** Admin ve gizli deneme rotalarında arama motoru indekslemesini kapatır. */
export default function RouteSeoGuard() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin')) {
      applyPageSeo({
        title: 'Yönetim paneli',
        description: 'Forum istatistikleri yönetim alanı.',
        keywords: '',
        noindex: true,
      });
    } else if (pathname.startsWith('/otomobil/admin') || pathname === '/otomobil/login') {
      applyPageSeo({
        title: 'Otomobil yönetimi',
        description: 'Otomobil kataloğu yönetim paneli.',
        keywords: '',
        noindex: true,
      });
    } else if (pathname === '/otomobil' || pathname.startsWith('/otomobil/')) {
      applyPageSeo({
        title: 'Otomobil',
        description: 'Geliştirme aşamasında otomobil listeleme denemesi.',
        keywords: '',
        noindex: true,
      });
    }
  }, [pathname]);

  return null;
}
